import { createContext } from "react";
import { ConfiguratorInput } from "src/api/generated/io/aavo/applications/db/erp/types/configuratorInput.ts";
import {
	ConfigurationCheckpointEntry,
	ConfigurationCheckpointState
} from "src/components/views/erp/configurator/configuratorForm/checkpoints/configurationCheckpoints.ts";
import { useContextOrThrow } from "../../../../../../utils/useContextOrThrow.tsx";

export interface ConfigurationCheckpointContextValue {
	state: ConfigurationCheckpointState;
	entries: ConfigurationCheckpointEntry[];
	createCheckpoint: (configuratorInput: ConfiguratorInput, currentInputVersion: number) => Promise<void>;
	isCreating: boolean;
}

export const ConfigurationCheckpointContext = createContext<ConfigurationCheckpointContextValue | undefined>(undefined);

export function useConfigurationCheckpoints(): ConfigurationCheckpointContextValue {
	return useContextOrThrow(ConfigurationCheckpointContext);
}
